// Dev-only API-channel pin — MUST stay the SECOND import of index.js
// (right after rootMappedBoot.js, which owns slot 1 for the whitelabel MWT
// contract and never reads @symbo.ls/channels), so it runs before anything
// in the @symbo-ls/workspace-shared graph can memoize currentChannel().
//
// Replaces the old inline <script> pin in index.html. That script could not
// read the launcher's SYMBOLS_API_CHANNEL — Parcel does NOT substitute
// process.env inside classic inline scripts (probed 2026-08-26: the literal
// survives into the built HTML) — so it defaulted to 'local' and PERSISTED
// it into localStorage.symbols_api_channel on every param-less load. That
// stale 'local' pin is why channels-direct consumers kept dialing
// http://localhost:8080 (connection refused on machines with no local
// server) even when ?channel=development and the env pin had the SDK
// correctly on dev.api.
//
// Precedence — mirrors workspaceApiBase.js rungs 1/2/5 exactly:
//   1. ?channel=<name>       per-tab choice; the ONLY thing we persist
//   2. SYMBOLS_API_CHANNEL   launcher env, inlined by Parcel ('dev' aliases
//                            to 'development'); per-process, never persisted
//   3. stored localStorage   an earlier explicit per-tab choice
//   4. 'development'         the team default (Nika, 2026-08-25)
// Non-local hosts never enter this block — deployed surfaces keep resolving
// by hostname. setChannel() also invalidates channels' memo, so ordering
// bugs fail soft instead of pinning a stale read.
import { isKnownChannel, setChannel } from '@symbo.ls/channels'

try {
  const host = typeof window !== 'undefined' ? window.location.hostname : ''
  const isLocalHost = host === 'localhost' || host.endsWith('.localhost')
  if (isLocalHost) {
    const urlChannel = new URLSearchParams(window.location.search).get('channel')
    let envChannel = null
    try {
      envChannel = process.env.SYMBOLS_API_CHANNEL || null
    } catch (_) {
      /* no bundler substitution — leave null */
    }
    if (envChannel === 'dev') envChannel = 'development'
    let stored = null
    try {
      stored = window.localStorage.getItem('symbols_api_channel')
    } catch (_) {
      /* sandboxed storage — ignore */
    }
    const pick = (name) => (name && isKnownChannel(name) ? name : null)
    const channel = pick(urlChannel) || pick(envChannel) || pick(stored) || 'development'
    setChannel(channel)
    if (pick(urlChannel)) {
      try {
        window.localStorage.setItem('symbols_api_channel', urlChannel)
      } catch (_) {
        /* sandboxed storage — the per-tab pin still applied above */
      }
    }
  }
} catch (_) {
  /* the dev pin must never block boot */
}
